import { ajaxPost } from 'Modules/ajax';
import actionsTypes from '../actions/types';
import {
  getPaymentInformationFailure,
  getPaymentInformationRequest,
  getPaymentInformationSuccess,
} from '../actions';

export default (store) => (next) => async (action) => {
  const nextReturn = next(action);

  if (action.type === actionsTypes.GET_PAYMENT_INFORMATION) {
    const { body } = action.payload;

    store.dispatch(getPaymentInformationRequest());

    try {
      const { data } = await ajaxPost('/subscriptions/create-subscription/check', {
        data: {
          promotionCode: body.promotionCode,
          schedule: body.schedule,
          product: body.product,
          country: body.country,
        },
      });
      store.dispatch(getPaymentInformationSuccess(data));
    } catch (e) {
      store.dispatch(getPaymentInformationFailure(e));
    }
  }

  return nextReturn;
};
